<script>
  import {
    AlertCircleIcon,
    Edit3Icon,
    PlusIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      AlertCircleIcon,
      Edit3Icon,
      PlusIcon,
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
      errors: {
        type: null,
        required: true,
      },
      isTailwind: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      tryToAddFieldGroupParams (element) {
        const length = Object.keys(this.value || []).length + 1
        const name = `New Group ${length}`
        const newGroup = {
          editedKey: name,
          editable: true,
          isNew: true,
          fields: [],
        }
        this.$set(this.value, name, newGroup)
        this.$forceUpdate()
        setTimeout(() => element.blur(), 500)
      },
      tryToToggleEditGroup (key, param) {
        if (param.editable && param.isNew) {
          delete this.value[key]
          return this.$forceUpdate()
        }
        param.editedKey = key.toLowerCase()
        param.editable = !param.editable
        this.$forceUpdate()
      },
      tryToRemoveGroup (key, param) {
        delete this.value[key]
        this.$forceUpdate()
      },
      tryToRenameGroup (key, param) {
        const done = () => {
          delete param.editedKey
          delete param.editable
          this.$forceUpdate()
        }

        if (param.isNew) {
          if (this.value[param.editedKey.toLowerCase()]) {
            this.$toasted.toast('You have duplicates Group Names. Please, remove the duplicates.', {
              title: 'You have duplicates Group Names. Please, remove the duplicates.',
              variant: 'danger', colour: 'red',
            })
            return done()
          }

          delete param.isNew
          delete this.value[key]
          this.value[param.editedKey.toLowerCase()] = { fields: [], }
        } else {
          if (key.toLowerCase() === param.editedKey.toLowerCase()) {
            return done()
          }
          if (this.value[param.editedKey.toLowerCase()]) {
            return this.$toasted.toast('You have duplicates Group Names. Please, remove the duplicates.', {
              title: 'You have duplicates Group Names. Please, remove the duplicates.',
              variant: 'danger', colour: 'red',
            })
          }

          this.value[param.editedKey.toLowerCase()] = this.value[key]
          delete this.value[key]
        }
        return done()
      },
      tryToEditParamField (key, oldName, newName, content) {
        const entity = this.value[key].fields.find(field => field.key.toLowerCase() === oldName.toLowerCase())
        this.$set(entity, 'editable', false)
        if (oldName !== newName) {
          const exists = this.value[key].fields.filter(field => field.key.toLowerCase() === newName.toLowerCase())
          if (exists.length) {
            this.$set(entity, 'editable', true)
            this.$set(entity, 'isError', true)
            this.$forceUpdate()
            return this.$toasted.toast('You have duplicate Field Names, please remove the duplicates.', {
              title: 'You have duplicate Field Names, please remove the duplicates.',
              variant: 'danger', colour: 'red',
            })
          }
          this.$set(entity, 'key', newName)
          this.$set(entity, 'value', content)
          this.$set(entity, 'isError', false)
        } else {
          this.$set(entity, 'value', content)
          this.$set(entity, 'isError', false)
        }
        this.$forceUpdate()
      },
      tryToRemoveParamsField (key, name) {
        const entityIndex = this.value[key].fields.findIndex(field => field.key.toLowerCase() === name.toLowerCase())
        this.$delete(this.value[key].fields, entityIndex)
        this.$forceUpdate()
      },
      tryToAddParamField (key, param, element) {
        const length = this.value[key].fields.length + 1
        let keyValue = `Key ${length}`
        let index = 0

        while (this.value[key].fields.findIndex(el => el.key === keyValue) !== -1) {
          keyValue = `Key ${length + index++}`
        }

        this.value[key].fields.push({
          key: keyValue,
          value: '',
          editable: true,
          isError: false,
        })
        this.$forceUpdate()
        setTimeout(() => element.blur(), 500)
      },
      generateRefKey(partOne, partTwo){
        return `${this.normalise(partOne)}-${this.normalise(partTwo)}`
      },
      normalise(value){
        return value.replaceAll(' ','_').toLowerCase()
      },
      toggleEdit(field){
        field.editable = !field.editable
        this.$forceUpdate()
      },
    },
  }
</script>

<template>
  <div>
    <BaseCollapseBox
      v-for="(param, key) in value"
      :key="'params-' + key"
      :hide-label="param.editable"
      :label="key"
      :name="key"
    >
      <template v-slot:buttons>
        <div v-if="param.editable" class="header-edit-input">
          <input
            v-model="param.editedKey"
            class="form-control form-control-sm !tw-rounded-md !tw-h-7"
          />
        </div>
        <div class="header-buttons !tw-right-1.5 !tw-top-1.5 md:!tw--top-3 md:!tw-right-5">
          <button 
            v-if="!param.editable" 
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="tryToToggleEditGroup(key, param)"
          ><Edit3Icon size="1x" class="custom-class"></Edit3Icon></button>
          <button 
            v-if="param.editable && !param.isNew" 
            type="button"
            class="btn btn-outline-danger btn-sm hover:!tw-bg-negative"
            @click="tryToRemoveGroup(key)">Remove</button>
          <button 
            v-if="param.editable" 
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="tryToRenameGroup(key,param)">Save</button>
          <button 
            v-if="param.editable" 
            type="button"
            class="btn btn-outline-secondary btn-sm"
            @click="tryToToggleEditGroup(key, param)">Cancel</button>
        </div>
      </template>

      <div
        v-if="value[key] && value[key].fields && value[key].fields.length > 0"
        class="tw-pt-3 md:tw-pt-u">
        <BaseDynamicFieldInput
          v-for="(field) in value[key].fields"
          :key="'params-' + key + '-field-' + field.key"
          :group="key"
          :field-name="field.key"
          :field-content="field.value"
          :edit="field.editable"
          :is-tailwind="isTailwind"
          :toggle-edit-function="() => toggleEdit(field)"
          :is-error="field.isError"
          @editClick="tryToEditParamField"
          @deleteClick="tryToRemoveParamsField"
        />
      </div>

      <div
        :class="{
          'group-add-more': !isTailwind,
          'tw-px-2 tw-pt-5 tw-flex tw-flex-col md:tw-items-center md:tw-flex-row tw-gap-x-3': isTailwind,
        }">
        <button 
          :ref="generateRefKey('addFieldButton', key)" 
          type="button"
          class="btn btn-add tw-flex-shrink-1" 
          :disabled="param.isNew" 
          @click="tryToAddParamField(key, param, $refs[generateRefKey('addFieldButton', key)][0])"
        ><PlusIcon size="1.2x" class="custom-class mr-1" /> Add Field</button>
        <p class="note-content tw-opacity-50" :class="{ 'tw-flex md:tw-items-center tw-italic md:tw-mr-2 tw-pt-2 md:tw-pt-u tw-text-gray-500': isTailwind }"><AlertCircleIcon size="1.5x" class="custom-class mr-2 tw-min-w-4"/>Each product might have different information. Use this field to customize each product’s needs</p>
      </div>
    </BaseCollapseBox>

    <p v-if="errors && errors.params" class="text-danger p-3">{{ errors.params }}</p>

    <div
      :class="{
        'group-add-more': !isTailwind,
        'tw-px-5 tw-pt-5 tw-flex tw-flex-col md:tw-items-center md:tw-flex-row tw-gap-x-3': isTailwind,
      }">
      <button
        ref="addFieldGroupButton" 
        type="button"
        class="btn btn-add tw-flex-shrink-1" 
        @click="tryToAddFieldGroupParams($refs.addFieldGroupButton)"
      ><PlusIcon size="1.2x" class="tw-mr-1" /> Add Field Group</button>
      <p class="note-content tw-opacity-50" :class="{ 'tw-flex md:tw-items-center tw-italic md:tw-mr-2 tw-pt-2 md:tw-pt-u tw-text-gray-500': isTailwind }"><AlertCircleIcon size="1.5x" class="tw-mr-2 tw-min-w-6"/>Each product might have different information. Use this field to customize each product’s needs</p>
    </div>
  </div>
</template>
